module.exports = __webpack_public_path__ + "static/media/ncl_ida.cb352616.png";